// Provides the WHS terminology strings (Ruby-side WhsTermFormats.formats) to the
// whole handicap-history tree, so leaf components interpolate the correct
// hs / hs-sim labels ("SLOPE®" vs "Difficulty Index", "H.I.™" vs "HDCP", …)
// straight from the single source of truth instead of prop-drilling an isSim
// flag and keeping a parallel copy of the terms in the locale files (REACT-091).
import { createContext, useContext } from 'react'

export const WhsTermsContext = createContext({})

export const useWhsTerms = () => useContext(WhsTermsContext)
